import { useEffect, useRef } from 'react';

const useXtremePush = () =>{

    const xtremepushCacheRef = useRef([])
    const xtremepushTimer = useRef(null)
    const timeCounter = useRef(0)

    // useEffect(()=>{
    //     setInterval(()=>{
    //         console.warn('xtremepushCache', xtremepushCacheRef)
    //     },5000)
    // },[])

    useEffect(()=>{
        xtremepushTimer.current = setInterval(()=>{
            timeCounter.current += 3
            if(window.WAGdpr?.isEU()){
                clearInterval(xtremepushTimer.current)
            }
            if(window.xtremepush){
                xtremepushCacheRef.current.forEach(item => {
                    window.xtremepush(...item)
                });
                clearInterval(xtremepushTimer.current)
            }
            if(timeCounter.current >= 60) {
                clearInterval(xtremepushTimer.current)
            }
        },3000)
        
        return ()=>{
            clearInterval(xtremepushTimer.current)
        }
    },[])

    const xtremePush = (...args) =>{
        // xtremepushCacheRef.current.push(args)
        // return
        if(window.WAGdpr?.isEU() || !window.globalConfig.ENABLE_XTREMEPUSH || window.BetLiteSite) return
        if(!window.xtremepush){
            xtremepushCacheRef.current.push(args)
            return
        }
        window.xtremepush(...args)
    }

    return {
        xtremePush
    }
}

export default useXtremePush

